// extracted by mini-css-extract-plugin
module.exports = {"error":"text-input_error__5kqUH","required":"text-input_required___TAWz"};